import { create } from "zustand";
import type { Product } from "@core/types";

export interface ProductDetailSheetState {
  productId: Product["id"] | null;
  productType?: Product["type"];
}

export interface ProductDetailSheetActions {
  open: (productId: Product["id"], productType?: Product["type"]) => void;
  close: () => void;
}

const initialState: ProductDetailSheetState = {
  productId: null,
  productType: undefined,
};

export const useProductDetailSheetStore = create<ProductDetailSheetState & ProductDetailSheetActions>((set) => ({
  ...initialState,

  open: (productId, productType) => set({ productId, productType }),

  close: () => set(initialState),
}));
